var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"link"},[_c('a',{attrs:{"rel":"noopener","target":"_blank","href":_vm.linkWithHttps,"title":_vm.descricao}},[_vm._v(" "+_vm._s(_vm.linkWithOutHttps)+" "),(_vm.extra)?_c('small',[_vm._v(_vm._s(_vm.extra))]):_vm._e(),_c('fontawesome',{attrs:{"icon":"link"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }